// client/src/context/TabPaneContext.js
import { createContext } from 'react';

/**
 * The id of the tab whose pane is rendering. Null outside the tab host, so
 * anything tab-scoped can no-op cleanly in the untabbed shell.
 */
const TabPaneContext = createContext(null);

export default TabPaneContext;
